<template>
  <div class="page-graduate-query">
    <div class="header">
      <a class="logo"></a>
    </div>
    <div class="body">
      <div class="form-wrap">
        <div class="form-title">毕业证书查询</div>
        <div class="form-content">
          <el-form ref="form" :model="form" :rules="rules">
            <el-form-item prop="regNo">
              <el-input
                v-model.trim="form.regNo"
                placeholder="请输入学号"
                clearable>
                <template #prefix>
                  <a class="form-icon icon-student-no"></a>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="trueName">
              <el-input
                v-model.trim="form.trueName"
                placeholder="请输入姓名"
                clearable>
                <template #prefix>
                  <a class="form-icon icon-username"></a>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="authCode" class="auth-code-item">
              <el-input
                v-model.trim="form.authCode"
                placeholder="请输入验证码"
                clearable
                class="auth-code-input"
                @keyup.native.enter="handleQuery">
                <template #prefix>
                  <a class="form-icon icon-auth-code"></a>
                </template>
              </el-input>
              <img :src="`/index/plat/authImg/graduateQuery?t=${timeStamp}`"
                   alt="验证码"
                   title="点击更换验证码"
                   class="auth-code-img"
                   @click="reloadAuthCode"/>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="form-footer">
        <el-button
          type="primary"
          :loading="committing"
          round
          @click="handleQuery">
          {{ committing ? '查询中' : '查询' }}
        </el-button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'GraduateQueryPage',
  data () {
    return {
      timeStamp: Date.now(),
      form: {
        regNo: '',
        trueName: '',
        authCode: ''
      },
      rules: {
        regNo: [
          { required: true, message: '请输入学号', trigger: 'blur' }
        ],
        trueName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        authCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      committing: false
    }
  },
  methods: {
    reloadAuthCode () {
      this.timeStamp = Date.now()
    },
    handleQuery () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false
        }

        this.committing = true
        this.$ajax({
          url: '/index/graduate/query',
          method: 'post',
          data: this.$qs.stringify({
            regNo: this.form.regNo,
            trueName: this.form.trueName,
            authCode: this.form.authCode
          })
        }).then(response => {
          if (response.data) {
            if (response.data.errorCode === 0) {
              // 跳转到结果页面，将数据通过路由params传递（不显示在URL中）
              const resultData = response.data.list || []
              this.$router.replace({
                name: 'GraduateResult',
                params: {
                  resultList: resultData
                }
              })
            } else {
              this.$message.error(response.data.message || '查询失败')
            }
          }
        }).catch(() => {
          this.$message.error('网络请求失败')
        }).finally(() => {
          this.committing = false
          this.$nextTick(() => {
            this.form.authCode = ''
            this.reloadAuthCode()
          })
        })
      })
    }
  }
}
</script>

<style lang="scss">
.page-graduate-query {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 30px 15px;

  .header {
    .logo {
      display: block;
      height: 42px;
      background: url('~@/assets/common/graduate-logo.png') center no-repeat;
      background-size: contain;
    }
  }

  .body {
    margin-top: 40px;

    .form-wrap {
      padding: 0 0 60px;
      border-radius: 8px;
      background-color: #FFF;
      box-shadow: 0 0 6px rgba(0, 0, 0, .1);

      .form-title {
        padding: 20px 30px 0;
        margin-bottom: 15px;
        color: #005ea6;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
      }

      .form-content {
        padding: 0 30px;

        .el-form {
          .el-form-item {
            margin-bottom: 20px;

            &:last-child {
              margin-bottom: 0;
            }

            .el-input {
              .el-input__inner {
                height: 40px;
                line-height: 40px;
                padding-left: 40px;
              }

              .el-input__prefix {
                left: 10px;
                display: flex;
                align-items: center;

                .form-icon {
                  display: inline-block;
                  width: 24px;
                  height: 24px;
                  background: center no-repeat;
                  background-size: contain;
                  vertical-align: -5px;

                  &.icon-student-no {
                    background-image: url('~@/assets/common/graduate/icon-idcard.png');
                  }

                  &.icon-username {
                    background-image: url('~@/assets/common/graduate/icon-username.png');
                  }

                  &.icon-auth-code {
                    background-image: url('~@/assets/common/graduate/icon-authCode.png');
                  }
                }
              }

              .el-input__suffix {
                right: 5px;

                .el-input__suffix-inner {
                  .auth-code-img {
                    height: 28px;
                    vertical-align: middle;
                    cursor: pointer;
                  }
                }
              }
            }

            // 验证码输入框特殊处理
            &.auth-code-item {
              position: relative;

              .auth-code-img {
                position: absolute;
                right: 0;
                top: 0;
                height: 40px;
                width: 130px;
                cursor: pointer;
                border-radius: 4px;
                border: 1px solid #DCDFE6;
              }
            }
          }

          // 验证码输入框宽度
          .auth-code-item {
            .auth-code-input.el-input {
              width: calc(100% - 140px) !important;
              display: inline-block !important;
              vertical-align: middle;
            }
          }
        }
      }
    }

    .form-footer {
      display: flex;
      justify-content: center;
      transform: translateY(-50%);

      .el-button {
        width: 65%;
        max-width: 300px;
        height: 44px;
        font-size: 16px;
        background-color: #005ea6 !important;
        border-color: #005ea6 !important;
        border-radius: 22px !important;

        &:hover,
        &:focus {
          background-color: #006bb8 !important;
          border-color: #006bb8 !important;
        }
      }
    }
  }

}

// 移动端适配
@media screen and (max-width: 768px) {
  .page-graduate-query {
    .body {
      .form-wrap {
        .form-content {
          padding: 0 20px;
        }
      }
    }
  }
}
</style>
